import { useCallback } from 'react';

import { useRoutePath } from './useRoutePath';

export function useStepRoutePath(baseUrl: string): (stepSlug: string) => string {
	const routePath = useRoutePath();

	return useCallback((stepSlug: string) => routePath(`${baseUrl}/${stepSlug}`), [routePath, baseUrl]);
}
